import { Times } from '@assets/svgs';
import { IconButton } from '@components/iconButton';
import { Grid, Typography } from '@mui/material';
import { SubjectivityLibraryTypeAhead } from '@pages/QuoteDetails/sidebarItems/subjectivities/SubjectivityLibraryTypeAhead';
import { TSubjectivityLibraryItem } from '@services/subjectivity/subjectivity-library/useSearchPaginatedSubjectivityLibrary';
import { Dispatch, SetStateAction } from 'react';

export const SubjectivityBulkAddForm = ({
  selectedItems = [],
  onChangeSelectedItems,
  availableLOIIds,
}: {
  selectedItems: TSubjectivityLibraryItem[];
  onChangeSelectedItems: Dispatch<SetStateAction<TSubjectivityLibraryItem[]>>;
  availableLOIIds?: string[];
}) => {
  const handleDelete = (item: TSubjectivityLibraryItem) => {
    onChangeSelectedItems((prev) => prev.filter((i) => i.id !== item.id));
  };

  return (
    <Grid container spacing={2}>
      <SubjectivityLibraryTypeAhead
        mode='multiple'
        selectedItems={selectedItems}
        onSelectFromList={(items) => {
          onChangeSelectedItems(items as TSubjectivityLibraryItem[]);
        }}
        availableLOIIds={availableLOIIds}
      />

      <Grid>
        {selectedItems.map((item) => (
          <Grid key={item.id} size={{ xs: 12 }} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
            <IconButton size='small' onClick={() => handleDelete(item)} sx={{ top: '2px' }}>
              <Times />
            </IconButton>
            <Typography variant='bodySmall'>{item.name}</Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
